<template>
  <container :class="[baseCss, `text-${align}`]">
    <container v-if="icon" :class="['mb-2', 'p-2']">
      <icon :name="icon" :icon-provider="iconProvider" :size="iconSize" :color="color" :color-lightness="colorLightness" />
    </container>
    <container v-if="title" v-html="title" :class="[`text-${titleFontSize}`, 'mb-2', setTextColor(), 'font-semibold']" />
    <divider v-if="title && subTitle" />
    <container v-if="subTitle" v-html="subTitle" :class="[`text-${subTitleFontSize}`, 'mt-2', setTextColor(), 'font-semibold']" />
    <container :class="['mt-2', setTextColor()]">
      <slot />
    </container>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Empty',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('empty', [])
    }
  },
  props: {
    align: {
      type: String,
      default: 'center',
      validator: value => {
        return [
          'left',
          'center',
          'right',
          'justify',
          'auto'
        ].includes(value)
      }
    },
    icon: {
      type: String,
      default: 'do-not-disturb'
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    iconSize: {
      type: Number,
      default: 2
    },
    color: {
      type: String,
      default: 'gray'
    },
    colorLightness: {
      type: Number,
      default: 400
    },
    title: {
      type: String
    },
    subTitle: {
      type: String
    },
    titleFontSize: {
      type: String,
      default: 'sm',
      validator: value => {
        return [
          'xs',
          'sm',
          'base',
          'md',
          'lg',
          'xl',
          '2xl',
          '3xl',
          '4xl',
          '5xl',
          '6xl',
          '7xl',
          '8xl',
          '9xl'
        ].includes(value)
      }
    },
    subTitleFontSize: {
      type: String,
      default: 'xs',
      validator: value => {
        return [
          'xs',
          'sm',
          'base',
          'md',
          'lg',
          'xl',
          '2xl',
          '3xl',
          '4xl',
          '5xl',
          '6xl',
          '7xl',
          '8xl',
          '9xl'
        ].includes(value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/empty/empty.vue